import React from 'react';
import './Phones.css';

import Icon from '../../../components/Icon/Icon';
import DocumentLinks from '../../../components/DocumentLinks/DocumentLinks';

const phones = ( props ) => (
	<section id="Phones">
		<h2>Using <span>Your</span> Phone</h2>
		<div className="section">
			<div className="inner-section">
				<p>
					Our phone system is VoIP, or Voice over IP. That means if the internet or power is out, so is the phone system! Here's a cheat sheet for all the features!
				</p>
				<div className="phones-info">
					<DocumentLinks docs={ props.docs } />
				</div>
				<p>
					It's important to answer the phone within three rings, or else the girl from "The Ring" will get you! If the phone is ringing for the whole office (not just your extension), answer it like this:
				</p>
				<p>
					"IDSI, this is <em>first name</em>. How can I help you?"
				</p>
			</div>
			<Icon icon="communication.ringGirl" title="Answering the phone" gradient="vertical invert" />
		</div>
	</section>
);

export default phones;



// WEBPACK FOOTER //
// ./src/pages/Communication/Phones/Phones.js